import { Paper, Stack, Typography } from '@mui/material'
import { SettingsRowLabelBlock } from '@/components/Settings/settingsRowLabelBlock'
import shared from '@/components/Settings/settingsShared.module.scss'
import styles from '@/components/Settings/GeneralSettingsContent.module.scss'
import { GeneralSettingsPrivacyModeCard } from './GeneralSettingsPrivacyModeCard'
import { GeneralSettingsSection } from './GeneralSettingsSection'

/** @param {{ paperFirst: string, paperLast: string }} props */
export function GeneralSettingsPrivacySection({ paperFirst, paperLast }) {
  return (
    <GeneralSettingsSection title="Privacy" introKey="general-privacy">
      <Stack spacing={0} className={shared.preferenceSectionRows}>
        <GeneralSettingsPrivacyModeCard paperClassName={paperFirst} />
        <Paper elevation={0} className={paperLast}>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} className={shared.preferenceRowLayout}>
            <SettingsRowLabelBlock title="Student Verification" description="Only .edu emails and specific educational domains are eligible for student verification." />
            <Typography component="span" className={styles.statusMuted}>Not eligible</Typography>
          </Stack>
        </Paper>
      </Stack>
    </GeneralSettingsSection>
  )
}
